<template>

  <div class="head">


    <div id="pc">
      <div>
        <img src="@/img/pc/logo.png" alt="">
        海鸥
      </div>

      <div class="menu">
        <div style="cursor: pointer;" id="menu1" :style="menuIndex==0?menuYes:menuNo" @click="onclick(0)"><span >首页</span></div>
        <div style="cursor: pointer;" id="menu2" :style="menuIndex==1?menuYes:menuNo" @click="onclick(1)"><span >安全性</span></div>
        <div style="cursor: pointer;" id="menu3" :style="menuIndex==2?menuYes:menuNo" @click="onclick(2)"><span >帮助中心</span></div>
        <div style="cursor: pointer;" id="menu4" :style="menuIndex==3?menuYes:menuNo" @click="onclick(3)"><span >关于我们</span></div>
        <div style="cursor: pointer;" id="menu5" :style="menuNo" @click="onclick(4)"><span >海鸥快传</span></div>
        <div style="cursor: pointer;" id="menu6" :style="menuNo" @click="onclick(5)"><span >海鸥网页</span></div>
      </div>

    </div>




    <div id='mobile'>

      <div class="mobile-header" :style="mobileHeaderStype">
        <div>
           <img src="@/img/mobile/logo@2x.png" alt="">
          <router-link to="/">海鸥</router-link>
        </div>

        <div class="menu">
          <img :src="menuUrl" alt="" @click="menuClick">

        </div>
      </div>


      <div v-show="overlayShow" @click="overlayClick">

        <div style="background-color: #ffff;">
          <div id="mobile-menu1" :style="menuIndex==0?menuMobileYes:menuMobileNo" @click="onclick(0)">
            首页
          </div>
          <div id="mobile-menu2" :style="menuIndex==1?menuMobileYes:menuMobileNo" @click="onclick(1)">
            安全性
          </div>
          <div id="mobile-menu3" :style="menuIndex==2?menuMobileYes:menuMobileNo" @click="onclick(2)">
            帮助中心
          </div>
          <div id="mobile-menu4" :style="menuIndex==3?menuMobileYes:menuMobileNo" @click="onclick(3)">
            关于我们
          </div>
           <div id="mobile-menu4" :style="menuIndex==4?menuMobileYes:menuMobileNo" @click="onclick(4)">海鸥快传</div>
        </div>

      </div>

      <div class="mobile-overlay" v-show="overlayShow" @click="overlayClick">

      </div>



    </div>

  </div>


</template>

<script>
  import api from "@/api/api";
  import request from '@/api/request';
  import {
    Notify
  } from 'vant';
  import {
    Dialog
  } from 'vant';
  export default {
    components: {

    }, props: {
    menuIndex: {
      type: Number,
      default: 0
    }
  },
    data() {
      return {
       
        menuYes: 'border-bottom: 4px solid #4371FF;color: #4371FF;',
        menuNo: 'border-bottom: 0px;color: #666666;',

        menuMobileBack: "mobile-menu1",
        menuMobileYes: 'color: #4371FF;',
        menuMobileNo: 'color: #666666;',
        mobileHeaderStype: '',
        overlayShow: false,
        menuUrl: require('@/img/mobile/Frame@2x(2).png')

      }
    },
    created() {


    },
    computed: {

    },
    mounted() {


    },

    destroyed() {

    },
    methods: {
      overlayClick() {
        this.menuUrl = require('@/img/mobile/Frame@2x(2).png')
        this.overlayShow = false;
        this.mobileHeaderStype = ''
      },
      menuClick() {
        if (this.overlayShow == true) {
          this.mobileHeaderStype = ''
          this.menuUrl = require('@/img/mobile/Frame@2x(2).png')
          this.overlayShow = false
        } else {
          this.mobileHeaderStype = 'background-color: #ffff'
          this.menuUrl = require('@/img/mobile/Frame@2x(1).png')
          this.overlayShow = true;
        }

      },
      onclick(key) {
if(key!=4&&key!=5){
this.menuIndex = key
}
        

        if (key == 0)
          this.$router.push({
            name: 'index'
          });
        if (key == 1)
          this.$router.push({
            name: 'security'
          });
        if (key == 2)
          this.$router.push({
            name: 'helpCenter'
          });
        if (key == 3)
          this.$router.push({
            name: 'aboutUs'
          });
        if (key == 4)
          window.open(api.apiConfig.haiouKc, '_blank');
        if (key == 5)
          window.open(api.apiConfig.haiouWeb, '_blank');


      },
      onclickMobile(key) {
        this.menuMobileBack = key

      },
      downApp() {
        var userAgent = navigator.userAgent;
        //console.log(userAgent)
        //alert(userAgent)
        var isAndroid = userAgent.indexOf('Android') > -1 || userAgent.indexOf('Adr') > -1; //android终端
        var isIOS = !!userAgent.match(/macintosh|mac os x/i);
        //alert(isIOS)
        //0 安卓 1 ios
        var type = 0;
        if (isIOS) {
          //window.location.href = 'https://apps.apple.com/cn/app/%E6%B5%B7%E9%B8%A5m/id6449927022'
          //window.location.href = 'itms-services://?action=download-manifest&amp;url=https://zd.oss.haiouchat.com/manifest.plist'
          window.location.href =
            'https://apps.apple.com/cn/app/%E6%B5%B7%E9%B8%A5-%E5%AE%89%E5%85%A8%E5%8A%A0%E5%AF%86%E8%81%8A%E5%A4%A9%E4%BA%A4%E5%8F%8B%E8%BD%AF%E4%BB%B6/id1584062834'


        } else {
          window.location.href = 'https://www.haiouchat.com/app/haiou.apk'
        }


      }


    }
  }

</script>

//pc端
<style scoped>
  /* 当屏幕宽度大于或等于768像素时，改为浮动布局 */
  @media (min-width: 768px) {

    #mobile {
      display: none;
    }

    #pc {
      height: 10vh;
      display: flex;
      flex-direction: row;
      align-items: center;
      justify-content: space-between;
    }

    #pc>div:first-child {
      width: 263px;
      display: flex;
      flex-direction: row;
      align-items: center;

      font-family: PingFang SC, PingFang SC;
      font-weight: 600;
      font-size: 24px;
      color: #4371FF;
      line-height: 28px;
      letter-spacing: 2px;
      text-align: left;
      font-style: normal;
      text-transform: none;

      padding-left: 160px;

    }

    #pc>div:first-child>img {
      width: 44px;
      height: 44px;
      margin-right: 8px;

    }

    #pc>div:last-child {
      width: 778px;
      display: flex;
      flex-direction: row;
      align-items: center;
    }

    #pc>div:last-child>div {
      margin-right: 48px;
      margin-top: 32px;
      height: 45px;

      font-family: PingFang SC, PingFang SC;
      font-weight: 500;
      font-size: 18px;
      color: #666666;
      line-height: 21px;
      text-align: right;
      font-style: normal;
      text-transform: none;


    }



  }

</style>

//移动端
<style scoped>
  /* 当屏幕宽度小于或等于768像素时，应用以下样式 */
  @media (max-width: 768px) {
    #pc {
      display: none;
    }


    #mobile {
      display: flex;
      flex-direction: column;
      align-items: center;
      width: 100%;
      position: absolute;
      top: 0px;
      z-index: 9999;


    }

    .mobile-header {
      width: 100%;
      height: 40px;
      display: flex;
      flex-direction: row;
      align-items: center;
      justify-content: space-between;
    }

    .mobile-header>div:first-child {

      display: flex;
      flex-direction: row;
      align-items: center;


      font-family: PingFang SC, PingFang SC;
      font-weight: 500;
      font-size: 12px;
      color: #4371FF;
      line-height: 14px;
      letter-spacing: 1px;
      text-align: left;
      font-style: normal;
      text-transform: none;



    }

    .mobile-header>div:first-child>img {
      width: 20px;
      height: 20px;
      margin-left: 16px;
      margin-right: 4px;

    }

    .mobile-header>div:last-child {


      margin-right: 16px;

    }

    .mobile-header>div:last-child>img {
      width: 24px;
      height: 24px;
    }


    #mobile>div:nth-child(2) {
      width: 100%;
    }

    #mobile>div:nth-child(2)>div {
      font-family: PingFang SC, PingFang SC;
      font-weight: 500;
      font-size: 16px;
      color: #4371FF;
      line-height: 19px;
      text-align: center;
      font-style: normal;
      text-transform: none;
    }

    #mobile>div:nth-child(2)>div>div {
      padding-top: 16px;
      padding-bottom: 16px;
    }

    .mobile-overlay {
      opacity: 0.5;
      height: 100vh;
      width: 100%;
      background-color: #666666;
    }


  }

</style>



// WEBPACK FOOTER //
// src/components/head/index.vue